// extracted by mini-css-extract-plugin
export default {"fitting":"WinterWheelFitting__fitting--GhXJb","title":"WinterWheelFitting__title--XSCo0","description":"WinterWheelFitting__description--_qP21"};